import styled from 'styled-components';

interface BannerContainerProps {
  backgroundImage: string;
}

export const BannerContainer = styled.div<BannerContainerProps>`
  display: flex;
  width: 100%;
  min-height: 296px;
  height: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 1.5rem;

  background: url(${({ backgroundImage }) => backgroundImage}),
    linear-gradient(
      48deg,
      rgba(142, 42, 48, 1) 0%,
      rgba(254, 156, 170, 1) 45%,
      rgba(255, 212, 212, 1) 100%
    );
  padding: 64px 0;
`;

export const BannerContent = styled.div`
  max-width: 1000px;
  width: 100%;

  display: grid;
  grid-template-columns: 600px 300px;
  grid-template-rows: auto auto;
  justify-content: space-between;
  color: #ffffff;

  h1 {
    grid-column: 1/2;
    grid-row: 1/2;
    font: 700 2rem/2.2rem 'Roboto', sans-serif;
    color: #ffffff;
  }

  p {
    grid-column: 1/2;
    grid-row: 2/3;

    font: 300 1rem/1.2rem 'Roboto', sans-serif;
    color: #ffffff;
  }

  button {
    grid-row: 3/4;
  }

  .loadingWrapper {
    height: 168px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    grid-column: 1/3;
  }

  .videoContainer {
    grid-column: 2/3;
    grid-row: 1/4;
    border-radius: 1rem;
    overflow: hidden;
    transition: all 0.2s ease;
    height: 168px;
    object-fit: contain;

    .iframeWrapper {
      position: relative;
      width: 100%;
      padding-bottom: 56.25%;
      overflow: hidden;
      border-radius: 1rem;

      .thumbnail {
        display: flex;
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
      }

      iframe {
        display: none;
        border: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      &.loaded {
        iframe {
          display: flex;
        }
        .thumbnail {
          display: none;
        }
      }
    }

    &:hover {
      transform: scale(1.01);
    }
  }
`;
